import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useResetPassword = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.RESET_PASSWORD, CLIENT_METHODS.POST)
